<template>
  <div class="app-container">
    <el-card shadow="always" class="card-box">
      <!-- 工具栏 -->
      <div class="filter-container">
        <el-row>
          <el-col :span="17">
            <el-input
              id="UserSearch-Guide"
              v-model="searchForm.search"
              class="filter-item"
              clearable
              placeholder="数据源名称模糊搜索"
              style="width: 200px"
            />
            <el-select
              v-model="searchForm.datasType"
              class="filter-item"
              style="width: 220px"
              placeholder="数据源类型"
              clearable
              multiple
            >
              <el-option label="mysql" value="mysql" />
              <el-option label="hive" value="hive" />
              <el-option label="doris" value="doris" />
            </el-select>
            <el-select
              v-model="searchForm.syncStatus"
              class="filter-item"
              style="width: 220px"
              placeholder="同步状态"
              clearable
              multiple
            >
              <el-option label="未同步" value="0" />
              <el-option label="待同步" value="1" />
              <el-option label="同步中" value="2" />
              <el-option label="同步完成" value="3" />
              <el-option label="同步失败" value="4" />
            </el-select>
            <el-select
              v-model="searchForm.showStatus"
              class="filter-item"
              style="width: 150px"
              placeholder="显示状态"
              clearable
            >
              <el-option label="显示" value="0" />
              <el-option label="隐藏" value="1" />
            </el-select>
            <el-select
              v-model="searchForm.delFlag"
              class="filter-item"
              style="width: 150px"
              clearable
              placeholder="删除状态"
            >
              <el-option label="有效" value="0" />
              <el-option label="待删除" value="1" />
              <el-option label="删除中" value="2" />
            </el-select>
            <el-button type="primary" class="filter-item" @click="getList">
              查询
            </el-button>
            <!--                        :disabled="searchForm.search==''&&searchForm.datasType==''&&searchForm.syncStatus==''&&searchForm.showStatus==''"-->
          </el-col>
          <el-col :span="7">
            <div class="filterTableHeader">
              <el-button
                class="filter-item"
                type="primary"
                size="small"
                icon="el-icon-circle-plus-outline"
                @click="addOrEdit('add')"
              >添加数据源
              </el-button>
            </div>
            <!-- table  筛选 -->
            <div class="filterTableHeader">
              <el-popover width="600" trigger="click">
                <el-button slot="reference" class="button_style">
                  <svg-icon icon-class="combined_shape" />
                  <span class="button_span_style">筛选列</span>
                  <svg-icon icon-class="on_down" style="width: 8px; height: 8px; vertical-align: 0em" />
                </el-button>
                <div class="checkbox-table-headers">
                  <template v-for="(item, index) in datasList.threads">
                    <el-checkbox :key="index" v-model="item.show" :disabled="index == 0 || index == datasList.threads.length - 1" @change="headChange">{{ item.name }}
                    </el-checkbox>
                  </template>
                </div>
              </el-popover>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--            表格-->
      <div style="margin-top: 10px; float: left; width: 100%; margin: 20px 0">
        <!-- 表格 -->
        <el-table
          v-loading="tableloading"
          border
          class="grayTableTile_01"
          :data="datasList.rows"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          @sort-change="handleSortChange"
        >
          <!--                    同步状态 0 未同步 1待同步 2同步中 3同步完成 4同步失败-->
          <el-table-column v-for="(itemtable, index) in datasList.threads" v-if="itemtable.name == '编辑'" :key="itemtable.id" :label="itemtable.name" fixed="right" align="right" :min-width="editWidth">
            <template slot-scope="scope">
              <!--                            <el-link type="primary" style="float: right" :underline="false" v-if="scope.row.syncState !== 1 && scope.row.syncState !== 2" @click="addOrEdit(scope.row)">编辑</el-link>-->
              <el-link type="primary" style="float: right" :underline="false" @click="handleConn(scope.row, 'test')">测试
                <!--                                <span v-if="scope.row.syncState !== 1 && scope.row.syncState !== 2" style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;"></span>-->
              </el-link>
              <el-link v-if="scope.row.syncState !== 1 &&scope.row.syncState !== 2 " type="primary" style="float: right" :underline="false"@click="handleConn(scope.row, 'sync')">同步
                <span style="float: right;width: 1px;height: 16px;background: #cccccc;margin: 0px 10px;margin-top: 3px;" />
              </el-link>
              <el-link v-if="scope.row.syncState === 0 ||scope.row.syncState === 3 ||scope.row.syncState === 4" type="primary" style="float: right" :underline="false" @click="handleConn(scope.row, 'delete')">删除
                <span style="float: right;width: 1px;height: 16px;background: #cccccc;margin: 0px 10px;margin-top: 3px;" />
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-else-if="(itemtable.show && itemtable.name == '创建时间') ||(itemtable.show && itemtable.name == '同步时间')" :key="itemtable.id" :label="itemtable.name" :property="itemtable.sortProperty" min-width="200"show-overflow-tooltip :sortable="itemtable.sortFlag ? 'custom' : false">
            <template slot-scope="scope">
              <span>{{ scope.row[itemtable.property] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="itemtable.show"
            :key="itemtable.id"
            :label="itemtable.name"
            :property="itemtable.sortProperty"
            min-width="150"
            show-overflow-tooltip
            :sortable="itemtable.sortFlag ? 'custom' : false"
          >
            <template slot-scope="scope">
              <div v-if="itemtable.property === 'viewState'">
                <el-switch
                  v-model="scope.row[itemtable.property]"
                  :active-value="0"
                  :inactive-value="1"
                  @change="statusChange(scope.row)"
                />
              </div>
              <div v-else-if="itemtable.property === 'syncState'">
                <span v-if="scope.row[itemtable.property] == 0">未同步</span>
                <span v-else-if="scope.row[itemtable.property] == 1">待同步</span>
                <span v-else-if="scope.row[itemtable.property] == 2">同步中</span>
                <span v-else-if="scope.row[itemtable.property] == 3">同步完成</span>
                <span v-else-if="scope.row[itemtable.property] == 4">同步失败</span>
              </div>
              <div v-else-if="itemtable.property === 'delFlag'">
                <span v-if="scope.row[itemtable.property] == 0">有效</span>
                <span v-else-if="scope.row[itemtable.property] == 1">待删除</span>
                <span v-else-if="scope.row[itemtable.property] == 2">删除中</span>
              </div>

              <span v-else>{{ scope.row[itemtable.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!--            分页-->
        <pagination
          :total="tableData.total"
          :page.sync="tableCondition.pageNum"
          :limit.sync="tableCondition.pageSize"
          style="margin-top: 10px; padding: 10px 0px 10px 0px"
          @pagination="getList"
        />
      </div>
    </el-card>

    <el-dialog :visible.sync="addOrEditDia" width="864px">
      <el-dialog width="30%" title="测试连接" :visible.sync="innerConnDia" :before-close="handleClose" append-to-body>
        <div>
          <div v-if="connStatus === 'pending'">
            <span v-loading="connLoad" />
            <span style="margin-left: 55px; font-size: 15px">测试连接中...</span>
          </div>
          <div v-else-if="connStatus === 'resolve'" class="fja" style="justify-content: start">
            <span class="iconfont icon-chenggong" style="color: #24915a" />
            <span style="margin-left: 20px; font-size: 15px">测试连接成功!</span>
          </div>
          <div v-else-if="connStatus === 'reject'" class="fja" style="justify-content: start">
            <span class="iconfont icon-jinggao--" style="color: #e22b4b" />
            <span style="margin-left: 20px; font-size: 15px">{{ connReject }}</span>
          </div>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="closeConn">关闭</el-button>
        </div>
      </el-dialog>

      <div slot="title" ref="addOrEditTitle" class="dialog-title-container" />
      <el-form
        ref="datasForm"
        :model="datasForm"
        label-width="100px"
        :rules="datasFormRules"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="数据源类型" prop="datasType">
              <el-select v-model="datasForm.datasType" placeholder="请选择" style="width: 240px" :disabled="cOrEOper !== 0 && cOrEOper !== ''">
                <el-option label="mysql" value="mysql" />
                <el-option label="hive" value="hive" />
                <el-option label="doris" value="doris" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="数据源名称" prop="datasName">
              <el-input v-model="datasForm.datasName" placeholder="请输入" style="width: 240px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="链接地址">
              <el-input v-model="datasForm.datasAddress" placeholder="请输入" :disabled="cOrEOper !== 0 && cOrEOper !== ''" style="width: 240px" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="端口" prop="datasPort">
              <el-input v-model="datasForm.datasPort" placeholder="请输入" style="width: 240px" type="number" :disabled="cOrEOper !== 0 && cOrEOper !== ''" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数据库" prop="datasDatabase">
              <el-input v-model="datasForm.datasDatabase" placeholder="请输入" :disabled="cOrEOper !== 0 && cOrEOper !== ''" style="width: 240px" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="用户名" prop="datasNum">
              <el-input v-model="datasForm.datasNum" placeholder="请输入" style="width: 240px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="密码" prop="datasPass">
          <el-input v-model="datasForm.datasPass" show-password placeholder="请输入" style="width: 240px" type="password" />
        </el-form-item>
        <el-form-item label="描述" prop="datasDes">
          <el-input v-model="datasForm.datasDes" placeholder="请输入" style="width: 660px" type="textarea" />
        </el-form-item>
        <el-form-item prop="showStatus">
          <span slot="label">显示状态
            <el-tooltip placement="top">
              <div slot="content">开启时在数据地图能够搜索到相应的元数据<br>关闭时不能搜索到</div><i class="el-icon-question" />
            </el-tooltip>
          </span>
          <el-switch v-model="datasForm.showStatus" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOrEditDia = false">取 消</el-button>
        <el-button @click="connTest('datasForm')">测试连接</el-button>
        <el-button type="primary" @click="handleAddOrEdit('datasForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="connDia" width="428px" :before-close="handleClose">
      <div slot="title" ref="connTitle" class="dialog-title-container" />
      <div v-if="connOper === 'delete'" class="fja" style="justify-content: start">
        <span class="iconfont icon-jinggao--" style="color: rgb(255, 163, 86)" />
        <span style="margin-left: 20px; font-size: 15px">确定要删除数据源吗？</span>
      </div>
      <div v-else>
        <div v-if="connStatus === 'pending'">
          <span v-loading="connLoad" />
          <span v-if="connOper === 'test'" style="margin-left: 55px; font-size: 15px">测试连接中...</span>
          <span v-else style="margin-left: 55px; font-size: 15px">同步中...</span>
        </div>
        <div v-else-if="connStatus === 'resolve'" class="fja" style="justify-content: start">
          <span class="iconfont icon-chenggong" style="color: #24915a" />
          <span v-if="connOper === 'test'" style="margin-left: 20px; font-size: 15px">测试连接成功!</span>
          <span v-else style="margin-left: 20px; font-size: 15px">已添加到同步队列!</span>
        </div>
        <div v-else-if="connStatus === 'reject'" class="fja" style="justify-content: start">
          <span class="iconfont icon-jinggao--" style="color: #e22b4b" />
          <span v-if="connOper === 'test'" style="margin-left: 20px; font-size: 15px">{{ connReject }}</span>
          <span v-else style="margin-left: 20px; font-size: 15px">{{ connReject }}</span>
        </div>
      </div>
      <div slot="footer">
        <div v-if="connOper === 'delete'">
          <el-button @click="closeConn"> 关闭</el-button>
          <el-button type="primary" @click="handleDelete">确定</el-button>
        </div>
        <div v-else><el-button type="primary" @click="closeConn"> 关闭</el-button></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { validateIP, isPort } from '@Sys~/utils/validate'

import {
  queryBy_searchForm,
  update_datasForm,
  create_datasForm,
  deleteBy_datas,
  testConnect_datas,
  syncConnect_datas
} from '@Dcs~/api/ajax_model'

export default {
  components: { Pagination },
  data() {
    // 此处对datasName数据源名称进行的校验，无论是添加还是编辑都需要与总数据库数据对比查重，所以需要发送请求
    const checkName = (rule, value, callback) => {
      if (!value || value.length < 1 || value.length > 20 || !value) {
        callback(new Error('长度在1-20个长度之间'))
      }
      var flag = new RegExp(
        '[`~!@#$^&*()=|{}\':;\',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？ ]'
      )
      if (flag.test(value)) {
        callback(new Error('请检查输入,不能含有特殊字符'))
      }
      // 此处对要添加的数据源名称进行检验，如果已存在，回调报错，所以需要发送请求，带上value，后端校验value是否已存在，或者后端返回所有数据，前端进行遍历校对。
      this.datasList.rows.forEach((item) => {
        if (item.name === value && this.cOrEOper !== value) {
          callback(new Error('该数据库名已存在'))
        }
      })
      callback()
    }
    return {
      searchForm: {
        search: '',
        datasType: [],
        syncStatus: [],
        showStatus: '',
        delFlag: undefined
      },
      datasForm: {
        datasType: '',
        datasName: '',
        datasAddress: '',
        datasPort: '',
        datasDatabase: '',
        datasNum: '',
        datasPass: '',
        datasDes: '',
        showStatus: true
      },
      // 添加还是编辑控制
      cOrEOper: '',
      // 同步还是测试控制
      connOper: '',
      // 删除某行数据--->暂存
      deleteDatas: '',
      // 测试以及同步失败返回的报错信息
      connReject: '',

      connStatus: 'pending',
      connLoad: true,
      addOrEditDia: false,
      innerConnDia: false,
      connDia: false,
      datasFormRules: {
        datasType: [
          { required: true, message: '请输入数据源类型', trigger: 'change' }
        ],
        datasAddress: [
          { required: true, validator: validateIP, trigger: 'blur' }
        ],
        datasPort: [{ required: true, validator: isPort, trigger: 'blur' }],
        datasPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        datasNum: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        datasName: [
          // { required: true, validator: checkName, trigger: 'blur' }
          { required: true, message: '请输入数据源名称', trigger: 'blur' }
        ]
      },
      tableData: {
        thead: [],
        tbody: [],
        total: 0
      },
      tableCondition: {
        searchValue: '',
        status: '', // "0":全部视频，"1":是，"2":否，
        pageNum: 1,
        pageSize: 10,
        orderByColumn: '', // 排序字段
        isAsc: 'desc' // 排序方式
      },
      datasList: {
        rows: [],
        threads: [
          {
            name: '数据源类型',
            property: 'type',
            sortFlag: true,
            sortProperty: 'type',
            show: true
          },
          {
            name: '数据源名称',
            property: 'name',
            sortFlag: false,
            sortProperty: 'datasName',
            show: true
          },
          {
            name: '链接地址',
            property: 'url',
            sortFlag: false,
            sortProperty: 'datasAddress',
            show: true
          },
          {
            name: '端口',
            property: 'port',
            sortFlag: false,
            sortProperty: 'datasPort',
            show: true
          },
          {
            name: '数据库名称',
            property: 'database',
            sortFlag: true,
            sortProperty: 'database',
            show: true
          },
          {
            name: '用户名',
            property: 'user',
            sortFlag: true,
            sortProperty: 'user',
            show: true
          },
          {
            name: '创建时间',
            property: 'createTime',
            sortFlag: true,
            sortProperty: 'createTime',
            show: true
          },
          {
            name: '同步时间',
            property: 'updateTime',
            sortFlag: false,
            sortProperty: 'updateTime',
            show: true
          },
          {
            name: '同步状态',
            property: 'syncState',
            sortFlag: false,
            sortProperty: 'syncState',
            show: true
          },
          {
            name: '描述',
            property: 'remark',
            sortFlag: false,
            sortProperty: 'datasDes',
            show: true
          },
          {
            name: '显示状态',
            property: 'viewState',
            sortFlag: false,
            sortProperty: 'showStatus',
            show: true
          },
          {
            name: '删除状态',
            property: 'delFlag',
            sortFlag: false,
            sortProperty: 'delFlag',
            show: true
          },
          {
            name: '编辑',
            property: '',
            sortFlag: false,
            sortProperty: '',
            show: true
          }
        ]
      },
      // param:{},
      eAsc: '',
      eOrder: '',
      platformOptions: [],
      statusList: [
        {
          label: '全部状态',
          value: ''
        },
        {
          label: '已启动',
          value: '0'
        },
        {
          label: '未启动',
          value: '1'
        }
      ],

      tableloading: false,

      dialogVisible_form: false,
      form_title: '',
      ruleForm: {
        name: '',
        platform: ''
      }
    }
  },
  computed: {
    editWidth() {
      return this.datasList.rows.find((item) => {
        return item.syncState !== 1 && item.syncState !== 2
      }) === undefined
        ? '60'
        : '160'
    },
    param() {
      return {
        types: this.searchForm.datasType.join(','),
        name: this.searchForm.search,
        viewState: this.searchForm.showStatus,
        syncStates: this.searchForm.syncStatus.join(','),
        delFlag: this.searchForm.delFlag,
        pageNum: this.tableCondition.pageNum,
        pageSize: this.tableCondition.pageSize,
        isAsc: this.eAsc,
        orderByColumn: this.eOrder
      }
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    // 添加数据源-----测试连接
    connTest(datas) {
      this.connStatus = 'pending'
      let param = {}
      this.$refs[datas].validate((valid) => {
        if (valid) {
          console.log('校验完成，发送测试连接请求')
          param = this.reForm()
          console.log(param)
          this.innerConnDia = true
          // 异步请求
          setTimeout(() => {
            testConnect_datas(param).then((res) => {
              if (res.code == '1') {
                this.connStatus = 'resolve'
              } else {
                this.connReject = res.msg
                this.connStatus = 'reject'
              }
            })
          }, 1000)
        } else {
          this.$message({
            message: '请检查并输入所有必填项',
            type: 'error'
          })
          return false
        }
      })
    },

    // 添加或修改数据源弹窗
    // 需要拿到本行数据，包括隐藏数据，----》密码
    addOrEdit(cOrEOper) {
      this.$nextTick(function() {
        if (this.$refs['datasForm']) {
          this.$refs['datasForm'].clearValidate()
          console.log('清洗')
        }
      })
      this.cOrEOper = ''
      if (cOrEOper === 'add') {
        this.datasForm = {
          datasType: '',
          datasName: '',
          datasAddress: '',
          datasPort: '',
          datasDatabase: '',
          datasNum: '',
          datasPass: '',
          datasDes: '',
          showStatus: true
        }
        this.addOrEditDia = true
        this.$refs.addOrEditTitle.innerHTML = '添加数据源'
      } else {
        this.addOrEditDia = true
        this.cOrEOper = cOrEOper.syncState
        // 此处需要深拷贝row对象，不然引用row的地址的话，修改datasForm的数据源时会同步修改总table数据的该row数据，导致一直显示数据源名称重复
        // 不能使用    this.datasForm = cOrEOper
        this.datasForm.id = cOrEOper.id
        this.datasForm.datasType = cOrEOper.type
        this.datasForm.datasName = cOrEOper.name
        this.datasForm.datasAddress = cOrEOper.url
        this.datasForm.datasPort = cOrEOper.port
        this.datasForm.datasDatabase = cOrEOper.database
        this.datasForm.datasNum = cOrEOper.user
        this.datasForm.datasPass = cOrEOper.password
        this.datasForm.datasDes = cOrEOper.remark
        this.datasForm.showStatus = cOrEOper.viewState === 0
        console.log(this.datasForm)
        this.$refs.addOrEditTitle.innerHTML = '修改数据源'
      }
    },
    // 列排序
    handleSortChange(e) {
      this.eOrder = e.prop
      this.param.orderByColumn = e.prop
      if (e.order === 'descending') {
        this.eAsc = 'DESC'
        this.tableCondition.pageNum = 1
        this.getList()
      } else if (e.order === 'ascending') {
        this.eAsc = 'ASC'
        this.tableCondition.pageNum = 1
        this.getList()
      }
      // console.log(e)
    },
    // 筛选列
    headChange() {
      console.log('筛选列')
    },
    // 关闭连接弹窗
    closeConn() {
      this.innerConnDia = false
      this.connDia = false
      setTimeout(() => {
        this.connStatus = 'pending'
      }, 200)
    },
    // 弹窗遮罩层拦截控制
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.closeConn()
        })
        .catch((_) => {
        })
    },
    // 测试连接-->发送请求-->成功或失败改变status状态
    handleConn(row, connOper) {
      this.connStatus = 'pending'
      this.connDia = true
      const test = (connFun) => {
        connFun(row).then((res) => {
          if (res.code == '1') {
            this.connStatus = 'resolve'
            this.getList()
          } else {
            this.connReject = res.msg
            this.connStatus = 'reject'
          }
        })
      }
      if (connOper === 'test') {
        this.connOper = 'test'
        this.$refs.connTitle.innerHTML = '测试连接'
        test(testConnect_datas)
      } else if (connOper === 'sync') {
        this.connOper = 'sync'
        this.$refs.connTitle.innerHTML = '同步'
        row = { id: row.id }
        console.log(row)
        test(syncConnect_datas)
      } else {
        this.connOper = 'delete'
        this.deleteDatas = row
        this.$refs.connTitle.innerHTML = '删除数据源'
      }
    },
    // 改变某行状态
    statusChange(data) {
      update_datasForm(data).then((res) => {
        if (res.code == '1') {
          this.getList()
        }
      })
    },
    // 添加或编辑数据源
    handleAddOrEdit(datas) {
      let param = {}
      this.$refs[datas].validate((valid) => {
        console.log(valid)
        if (valid) {
          param = this.reForm()
          console.log(param)
          if (this.datasForm.id == undefined) {
            create_datasForm(param).then((res) => {
              if (res.code == '1') {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.addOrEditDia = false
                this.getList()
              }
            })
          } else {
            update_datasForm(param).then((res) => {
              if (res.code == '1') {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.addOrEditDia = false
                this.getList()
              }
            })
          }
        } else {
          this.$message({
            message: '请检查并输入所有必填项',
            type: 'error'
          })
          return false
        }
      })
    },
    // 删除本行数据
    handleDelete() {
      console.log(this.deleteDatas.id)
      this.connDia = false
      deleteBy_datas({ id: this.deleteDatas.id }).then((res) => {
        if (res.code == '1') {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.addOrEditDia = false
          this.getList()
        }
      })
    },
    // 获取数据
    getList() {
      this.tableloading = true
      queryBy_searchForm(this.param).then((response) => {
        if (response.code == 1) {
          this.tableData.total = response.data.total
          this.datasList.rows = response.data.rows
          this.tableloading = false
        }
      })
    },
    reForm() {
      const param = {}
      param.id = this.datasForm.id
      param.type = this.datasForm.datasType
      param.name = this.datasForm.datasName
      param.url = this.datasForm.datasAddress
      param.port = parseInt(this.datasForm.datasPort)
      param.database = this.datasForm.datasDatabase
      param.user = this.datasForm.datasNum
      param.password = this.datasForm.datasPass
      param.remark = this.datasForm.datasDes
      param.viewState = this.datasForm.showStatus ? 0 : 1
      return param
    }
  }
}
</script>

<style lang="scss" scoped>
    .app-container {
        min-height: calc(100vh - 84px);
        background: #f0f2f5;
        padding: 0px 32px;
        padding-top: 23px;

        .el-card.is-always-shadow {
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 5%);
        }

        .card-box {
            padding: 4px;
            // ::v-deep .el-card__header {
            //   line-height: 30px;
            //   padding: 10px 15px;
            // }
        }

        > .el-select__tags {
            .el-tag {
                max-width: 60%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .el-select__input {
                margin-left: 2px;
            }
        }

        > .custom_form {
            .el-dialog__title {
                font-weight: 500;
                color: #333333;
                font-size: 20px;
            }

            .el-form-item__label {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
    }

    .filterTableHeader {
        margin-right: 10px;
        float: right;
    }

    .button_style {
        font-size: 16px;
        padding: 8px 10px;
        border-radius: 6px;
        border: 1px solid #e5e5e5;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);

        .button_span_style {
            font-weight: 400;
            line-height: 18px;
            font-size: 14px;
            padding: 0px 5px 0px 0px;
        }
    }
</style>
